import { render, staticRenderFns } from "./ManageModule.vue?vue&type=template&id=79e0575d"
import script from "./ManageModule.vue?vue&type=script&lang=js"
export * from "./ManageModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports